import { campaign } from 'api';
import { lsGetOfferGuid } from 'helpers/store';
import {
  SET_OPERATION_PROPERTY,
  SET_PATCH_OPERATION_FIELD,
  CANCEL_OPERATION,
  VALIDATION_STOCK,
  GET_DOCUMENTS,
  VALIDATE_DOCUMENT
} from 'store/actions/operation';
// import { OFFER_STATUS } from 'store/enums';

export default {
  [SET_OPERATION_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_OPERATION_PROPERTY, {
      field,
      value
    }),

  [SET_PATCH_OPERATION_FIELD]: ({ commit }, { field, value }) =>
    commit(SET_PATCH_OPERATION_FIELD, {
      field,
      value
    }),

  [CANCEL_OPERATION]: ({ commit }, { guid }) =>
    new Promise((resolve, reject) => {
      campaign
        .cancelOperation({
          id: guid || lsGetOfferGuid(),
          contractGenerated: true,
          cancelUser: 'AUTOMAT'
        })
        .then(() => resolve())
        .catch(err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        });
    }),

  [VALIDATION_STOCK]: ({ commit }) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      campaign
        .validationStock(guid)
        .then(resp => resolve(resp.data))
        .catch(err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        });
    }),
  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      campaign.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [GET_DOCUMENTS]: (params, data) =>
    new Promise((resolve, reject) => {
      campaign.getDocuments(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data);
        }
      );
    })
};
